import { mapState } from 'vuex';
import { formatDatetimeRange } from '~/utils/time_utils';

export default {
  computed: {
    ...mapState(['filters', 'num_active_smart_notifs']),
  },
  methods: {
    trackAnalytics(event, props) {
      window.analytics?.track(event, {
        ...this.commonProps(),
        ...props,
      });
    },
    commonProps() {
      const { date } = this.filters;
      const range = formatDatetimeRange(moment(date?.from), moment(date?.to), {
        style: 'date',
        timezone: date?.time_zone,
      });

      return {
        date_range: range,
        filter_values: this.filters,
        num_active_smart_notifs: this.num_active_smart_notifs,
      };
    },
  },
};
